import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">
          <img src="/images/logo-queencenter.svg" alt="Logo Queencenter" />
        </Link>
      </div>

      {/* Hamburger icon */}
      <button className="menu-toggle" onClick={toggleMenu}>
        {menuOpen ? (
          <img src="/images/close.svg" alt="Close menu" />
        ) : (
          <img src="/images/menu.svg" alt="Open menu" />
        )}
      </button>

      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <a href="/prijslijst">Prijslijst</a>
          </li>
          <li>
            <a href="/behandelingen">Behandelingen</a>
          </li>
          <li className="afspraak">
            <a href="/afspraak">Afspraak</a>
          </li>
        </ul>
        <div className="bg-mobile">
          <img
            src="/images/bg-mobile-menu-queencenter.jpg"
            alt="BG Queencenter"
          />
        </div>
        <div className="mobile-footer">
          <div className="contact-mobile">
            <p>
              Graafseweg 274
              <br /> 6532 ZV Nijmegen
            </p>
            <a href="tel:+31615852150">
              <span>Bel: +31 (0) 6 15 85 21 50</span>
            </a>
          </div>
          <div className="socials">
            <a
              href="https://www.instagram.com/queencenter.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/instagram.svg" alt="Instagram" />
            </a>
          </div>
        </div>
      </nav>

      {/* Optional overlay to close menu when clicking outside */}
      {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </header>
  );
};

export default Header;
